import React from "react";
import NumberFormat from "react-number-format";

interface CurrencyFormatProps {
    amount: number;
    currency?: string;
    decimals?: number;
    prefix?: string;
}

export default function CurrencyFormat(props: CurrencyFormatProps) {
    return (
        <NumberFormat
            value={props.amount}
            decimalScale={props.decimals || 2}
            decimalSeparator="."
            thousandSeparator=","
            fixedDecimalScale={true}
            prefix={props.prefix || "$"}
            suffix={` ${props.currency || "MXN"}`}
            displayType="text" />
    );
}

export function formatCurrency(props: CurrencyFormatProps) {
    return `$${props.amount.toLocaleString("es", { useGrouping: true, minimumFractionDigits: props.decimals || 2, currency: props.currency || "MXN" })} ${props.currency || "MXN"}`;
}